var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMsgWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.767 13.7L8.33227 12.8884L8.33227 12.8884C5.78296 12.0386 4.5083 11.6138 4.5083 10.8329C4.5083 10.0521 5.78296 9.62722 8.33227 8.77745L8.33227 8.77745L17.5549 5.70325C19.3486 5.10532 20.2455 4.80636 20.719 5.2798C21.1924 5.75323 20.8934 6.6501 20.2955 8.44385L20.2955 8.44387L20.2955 8.44389L17.2213 17.6665L17.2213 17.6665C16.3715 20.2158 15.9467 21.4905 15.1658 21.4905C14.385 21.4905 13.9601 20.2158 13.1104 17.6665L13.1104 17.6665L12.2989 15.2322L17.0152 10.516C17.4383 10.0929 17.4383 9.40696 17.0152 8.98389C16.5921 8.56082 15.9062 8.56082 15.4831 8.98389L10.767 13.7Z",
    fill: "#ffffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMsgWhiteIcon);
export default __webpack_public_path__ + "static/media/sendMsgWhiteIcon.2bd63b92cd55cc29998b478c3b438187.svg";
export { ForwardRef as ReactComponent };